import { Chevrone as IconChevrone } from 'education-icons';
import { Link, Text } from 'platform-components';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { useParams } from 'react-router';

import './promo__title.scss';

interface Props extends WithRouterPathProps {
    title: string;
}

interface Context {
    staticUrls: {
        labLibrarySubjectTab: string;
        labClassLibrarySubjectTab: string;
    };
}

const PromoTitle = ({ title, getRouterPath }: Props, context: Context) => {
    const { staticUrls } = context;
    const params = useParams<Record<string, string>>();
    const path = params.classId ? staticUrls.labClassLibrarySubjectTab : staticUrls.labLibrarySubjectTab;

    return (
        <div className="promo__title">
            <Link isRouter theme={Link.THEME.STEALTHY} to={getRouterPath(path, { tabSlug: 'timeline' })}>
                <IconChevrone className="promo__link-back" />
                <Text size={Text.SIZE.XXXL} weight={Text.WEIGHT.M}>
                    {title}
                </Text>
            </Link>
        </div>
    );
};

PromoTitle.contextTypes = {
    staticUrls: PropTypes.object.isRequired,
};

export default React.memo(withRouterPath(PromoTitle));
